import { Component, OnInit } from '@angular/core';

import { CurrentUserService }         from '../../shared/services/current-user.service';
import { SubscriptionsService }       from '../../subscriptions/subscriptions.service';
import { SubscriptionUser }           from '../../subscriptions/models/subscription-user';
import { PermissionsService }         from '../../shared/services/permissions.service';

@Component({
  selector: 'app-all-users',
  templateUrl: './all-users.component.html',
  styleUrls: ['./all-users.component.less']
})
export class AllUsersComponent implements OnInit {
  public users: SubscriptionUser[] = null;
  public minimalStateObj: {categoryType: string; mapping: string};
  public currentUserId: number;
  public canSetUserAdmin: boolean = false;
  private _subscriptionId: number = null;

  constructor(
      private api: SubscriptionsService,
      private currentUserService: CurrentUserService,
      private permissionsService: PermissionsService,
      ) {
    this.minimalStateObj = {categoryType: 'edition', mapping: 'user'};
    this.permissionsService.retrievePermissions().subscribe(permissions => {
      this.canSetUserAdmin = permissions.editionAdministration || permissions.nomadicAdministration || permissions.editionAnalytics;
    });
  }

  ngOnInit() {
    this.currentUserService.getUserData().subscribe(userData => {
      this._subscriptionId = userData.default_subscription;
      this.currentUserId = userData.sub;
      this.loadData();
    });
  }

  private loadData() {
    this.users = null;
    this.api.getSubscriptionUsers(this._subscriptionId).subscribe(users => this.users = users);
  }

  public setUserAdmin(user, state): void {
    this.api.setUserAdmin(this._subscriptionId, user.id, state).subscribe(() => user.is_admin = state);
  }

  public setUserActive(user, state): void {
    this.api.setUserActive(this._subscriptionId, user.id, state).subscribe(() => user.active = state);
  }
}



// WEBPACK FOOTER //
// /home/runner/work/nomadic-admin/nomadic-admin/nomadic-admin/src/app/dashboard/all-users/all-users.component.ts